import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class GetPoductSubTypeListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/product/productSubTypeList',
      requesterInfo,
    })
  }

  public async getPoductSubTypeList(): Promise<[]> {
    return await this.getAsync<[]>()
  }
}
